require('./index.scss')

import { useState } from 'react'
import { useSelector } from 'react-redux'

import ImageZoomDialog from './ImageZoomDialog'
import ZoomButton from './ZoomButton'

const ProductImageZoom = () => {
  const [isShowing, setIsShowing] = useState(false)
  const imageUrl = useSelector(state => state.asset.productImageUrl)

  return (
    <If condition={imageUrl}>
      <ZoomButton setIsShowing={setIsShowing} />
      <ImageZoomDialog
        imageUrl={imageUrl}
        isShowing={isShowing}
        setIsShowing={setIsShowing}
      />
    </If>
  )
}

export default ProductImageZoom
